import { Component, Input, OnChanges } from '@angular/core';
import Decimal from 'decimal.js';

@Component({
  selector: 'app-document-reverse-tax-table',
  templateUrl: './document-reverse-tax-table.component.html',
  styleUrls: ['./document-reverse-tax-table.component.css'],
})
export class DocumentReverseTaxTableComponent implements OnChanges {
  @Input() currency: string;
  @Input() locale: string;
  @Input() taxes: any[];
  reverseTaxTotal = new Decimal(0);

  constructor() {}

  ngOnChanges() {
    this.calculateTotals();
  }

  calculateTotals() {
    this.reverseTaxTotal = new Decimal(0);

    if (this.taxes) {
      this.taxes.forEach(tax => {
        this.reverseTaxTotal = this.reverseTaxTotal.plus(tax.totalTax);
      });
    }
  }
}
